module.exports = __webpack_public_path__ + "static/media/netwatch.b31d988a.png";